import uniqBy from 'lodash/uniqBy';
import * as React from 'react';
import { IAltText } from '../../../classes/alt-text';
import { Level } from '../../../classes/level';
import { CartSeat } from '../../../classes/seat';
import LevelSelectSvg from "../../../common/level-select/level-select";
import { convertStringToNumberList } from '../../../helpers/array-helpers';
import { getCurrencyFormat } from '../../../helpers/currency-format';
import { selectVenueLevel, unselectSeat } from '../../actions/seatmap-actions';
import { formatId } from '../../../helpers/string-format';



declare var Modernizr;

interface ILevelSelectProps {

    levels: Array<Level>;
    currentSeatmapId: string;
    cartSeats: Array<CartSeat>;
    dispatch: any;
    selectedPriceTypeIdsString: string;
    levelAvailableCountMessage: string;

    //LevelSelectSvg props
    altText: IAltText;
    svgStrokeColor: string;
    svgStrokeWidth: number;
    svgHoverFillColor: string;
    svgSelectedFillColor: string;
    svgDefaultFillColor: string;
    seatmapBackgroundImage: string;
    venueBackgroundPaths: Array<string>;
    venueSvgHighlightShading: string;
    seatmapSvgViewBox: string;
    onLevelSelectModalOpen: () => any;
    selectedLevelString: string;
    legend: string;

    currencyFormat: string;
    isExchange: boolean;
    exchangeFreeLabel: string;
    showLevelAvailabilityOnLevelFilter: boolean;
    showPricingOnLevelFilter: boolean;

    displaySeatFee?: boolean;
    feeAmountText?: string;
    venueLevelRangeFeesNote?: string;
}

class LevelSelect extends React.PureComponent<ILevelSelectProps, { hoveredLevel: number, selectedSeatmapId: string, isFlyout: boolean, isCheckbox: boolean }>{
    constructor(props) {
        super(props);
        this.state = {
            hoveredLevel: null,
            selectedSeatmapId: '',
            isFlyout: false,
            isCheckbox: false
        };
    }

    renderPrice(level: Level, selectedPriceTypeIds: Array<number>) {
        let pricesForSelectedPriceType = uniqBy(level.priceTypePrices, pr => { return pr.price });
        if (selectedPriceTypeIds.length > 0) {
            pricesForSelectedPriceType = uniqBy((level.priceTypePrices.filter(price => selectedPriceTypeIds.indexOf(price.priceTypeId) >= 0)), pr => { return pr.price });
        }

        if (pricesForSelectedPriceType.length < 1 || level.availableCount == 0)
            return '';
        else if (pricesForSelectedPriceType.length == 1)
            return (this.props.isExchange && this.props.exchangeFreeLabel.length > 0 && pricesForSelectedPriceType[0].price === 0) ? this.props.exchangeFreeLabel
                : getCurrencyFormat(this.props.currencyFormat, pricesForSelectedPriceType[0].price + (pricesForSelectedPriceType[0].feeAmount ? pricesForSelectedPriceType[0].feeAmount : 0));
        else {
            const prices = pricesForSelectedPriceType.map(pt => pt.price + (pt.feeAmount ? pt.feeAmount : 0));
            var sorted = prices.sort((a, b) => { return a - b; });
            var min = getCurrencyFormat(this.props.currencyFormat, sorted[0]);
            var max = getCurrencyFormat(this.props.currencyFormat, sorted[prices.length - 1]);
            return min + ' \u2013 ' + max;

        }
    }

    render() {
        const useTag = '<use xlink:href="#icon-close" />';
        return (
            <div className="map-level-select-container">
                <div className="map-level-select-wrapper" onClick={(evt) => { this._updateLegendFlyoutState(true) }}>
                    <div className="map-level-select-wrapper-inner">
                        <div className="map-level-select-image">
                            <LevelSelectSvg
                                altText={this.props.altText}
                                hoveredLevel={this.state.hoveredLevel}
                                levels={this.props.levels}
                                onMouseLeaveLevel={this._onMouseLeaveLevel}
                                onMouseOverLevel={this._onMouseOverLevel}
                                onSelectVenueLevel={this._onSelectVenueLevel}
                                venueBackgroundImage={this.props.seatmapBackgroundImage}
                                selectedLevelsString={this.props.currentSeatmapId.length > 0
                                    ? (this.props.levels.filter(lvl => lvl.seatmapId === this.props.currentSeatmapId)[0]?.levelNumber?.toString() ?? "")
                                    : ""}
                                svgDefaultFillColor={this.props.svgDefaultFillColor}
                                svgHoverFillColor={this.props.svgHoverFillColor}
                                svgSelectedFillColor={this.props.svgSelectedFillColor}
                                svgStrokeColor={this.props.svgStrokeColor}
                                svgStrokeWidth={this.props.svgStrokeWidth}
                                venueSvgHighlightShading={this.props.venueSvgHighlightShading}
                                venueSvgViewBox={this.props.seatmapSvgViewBox}
                                venueBackgroundPaths={this.props.venueBackgroundPaths}
                                svgClass="map-level-select-svg"
                            />
                        </div>

                        <fieldset>
                            <legend className="visually-hidden">{this.props.legend}</legend>
                            <ul className="venue-level-list">
                                {
                                    this.props.levels.sort((a, b) => { return b.levelNumber - a.levelNumber }).map((level, index) => {
                                        const formattedLevelName = `L${index}_${formatId(level.name)}`;
                                        return <li className={"venue-level-list-item" + (!level.disabled && this.state.hoveredLevel === level.levelNumber && !Modernizr.touchevents ? " active" : "") + (level.disabled ? " disabled" : "")} key={level.levelNumber}
                                            onMouseOver={() => { !level.disabled ? this._onMouseOverLevel(level.levelNumber) : null }}
                                            onMouseLeave={() => { this._onMouseLeaveLevel() }} data-level-id={level.levelNumber}>
                                            <input id={formattedLevelName} type={this.state.isCheckbox ? "checkbox" : "radio"}
                                                className={this.state.isCheckbox ? "checkbox-custom" : "radio-custom"}
                                                disabled={level.disabled}
                                                checked={level.selected || this.props.selectedLevelString.split(',').indexOf(level.levelNumber.toString()) >= 0} value={level.name}
                                                //onChange={() => this._onSelectVenueLevel(level)}
                                                onClick={() => { if (!this.state.isCheckbox) this._onSelectVenueLevel(level) }}
                                                name="levels-radios" />
                                            <label htmlFor={formattedLevelName}>{level.name}</label>

                                            <div className="venue-level-list-item-info">
                                                {this.props.showPricingOnLevelFilter ?
                                                    <>
                                                        <p className="venue-level-list-item-info-prices">
                                                            {this.renderPrice(level, convertStringToNumberList(this.props.selectedPriceTypeIdsString))}
                                                        </p>
                                                        {
                                                            this.props.displaySeatFee &&
                                                            <p className="small-italic venue-level-list-item-note">{this.props.venueLevelRangeFeesNote}</p>
                                                        }
                                                    </>
                                                    : null}
                                                {this.props.showLevelAvailabilityOnLevelFilter && level.availableCount >= 0 ?
                                                    <p className="venue-level-list-item-info-seats">
                                                        {this.props.levelAvailableCountMessage.replace("{0}", level.availableCount.toString())}
                                                    </p>
                                                    : null
                                                }
                                            </div>

                                        </li>
                                    })
                                }
                            </ul>
                        </fieldset>
                    </div>
                </div>
            </div>
        );
    }

    _onMouseOverLevel = (level) => {
        const newState = {
            ...this.state,
            hoveredLevel: level
        };

        this.setState(newState as any);
    };

    _onMouseLeaveLevel = () => {
        const newState = {
            ...this.state,
            hoveredLevel: null
        };

        this.setState(newState as any);
    };

    _onSelectVenueLevel = (level: Level) => {
        const newState = {
            ...this.state,
            selectedSeatmapId: level.seatmapId
        };

        this.setState(newState as any);
        this.props.dispatch(unselectSeat());
        this.props.dispatch(selectVenueLevel(level, this.props.cartSeats));
    };

    _updateLegendFlyoutState = (flyoutStatus) => {
        const newState = {
            ...this.state,
            isFlyout: flyoutStatus
        };

        this.setState(newState as any);
    };
}

export default LevelSelect;